customElements.component = 'showroom-signup';

if (!customElements.get(customElements.component)) {
  const selectors = {
    passwordInput: 'input[name="customer[password]"]',
    iconShow: ".eye-show",
    iconHide: ".eye-hide",
    hidden: "hidden"
  }

  class ShowroomSignup extends HTMLElement {
    constructor() {
      super();

      this.passwordInput = this.querySelector(selectors.passwordInput);
      this.iconShow = this.querySelector(selectors.iconShow);
      this.iconHide = this.querySelector(selectors.iconHide);

      this.iconShow.addEventListener("click", () => {
        this.passwordInput.type = "text";
        this.iconShow.classList.add(selectors.hidden);
        this.iconHide.classList.remove(selectors.hidden);
      })

      this.iconHide.addEventListener("click", () => {
        this.passwordInput.type = "password";
        this.iconShow.classList.remove(selectors.hidden);
        this.iconHide.classList.add(selectors.hidden);
      })
    }
  }

  customElements.define(customElements.component, ShowroomSignup);
}
